let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gGgsB")).then(() => parcelRequire('gsYgD'));